import { configure } from '@js-boot/react-i18n';
import deLang from './locales/de';
import enLang from './locales/en';
import { missingKeyHandler } from './utils';
import { isFeatureFlagEnabled } from '@/utils/isFeatureFlagEnabled.util';

// Feature flag keys
const FEATURE_FLAG_KEY = 'use_i18n';

const i18nInstance = configure({
  defaultNS: 'common',
  resources: {
    de: {
      common: deLang,
    },
    en: {
      common: enLang,
    },
  },
  overrides: {
    saveMissing: true,
    missingKeyHandler,
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    react: {
      transSupportBasicHtmlNodes: true,
    },
  },
});

const languageSetting = isFeatureFlagEnabled(FEATURE_FLAG_KEY) ? i18nInstance.language : 'de';

i18nInstance.changeLanguage(languageSetting);

export default i18nInstance;
